import React from 'react';
import { BiDownload, BiTrash } from 'react-icons/bi';

export const FileChooserAnswerField = ({
	files = [],
	onFileSelect,
	onFileDownload,
	onFileDelete
}) => {

	return (
		<div>
			<input type="File"
				className='form-control'
				multiple
				onChange={(e) => onFileSelect(e)} />
			<div className='UploadFileNameView d-block mt-2'>
			{
				files?.map((fileDat, fIndex) => (
					<div key={fIndex} className='d-flex align-items-center mb-2 gap-2 w-100'>
						<div className='UploadFileNameView_box py-2 px-3 border rounded bg-light flex-grow-1'>
							<span className='Up_fileName text-primary text-decoration-underline text-break cursor-pointer'
								onClick={() => onFileDownload(fileDat.id)}>
								{fileDat.fileName}
							</span>
						</div>
						<div className='d-flex gap-2 flex-shrink-0'>
							<span className='upload_Download cursor-pointer text-primary p-1' onClick={() => onFileDownload(fileDat.id)}>
								<BiDownload />
							</span>
							<span className='upload_Delete cursor-pointer text-danger p-1' onClick={() => onFileDelete(fileDat.id, fIndex, fileDat.fileName)}>
								<BiTrash />
							</span>
						</div>
					</div>
				))
			}
			</div>
		</div>
	);
};

export default FileChooserAnswerField;
